import { useState } from "react";
import { PauseCircle, Gift, Loader2, PlayCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const fmt = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString(undefined, { month: "long", day: "numeric" }) : "your next billing date");

/** Shows a scheduled/active pause (customer pause or referral free month) with a Resume-now action. */
export function MembershipPause({ m, token, onChange }) {
  const [busy, setBusy] = useState(false);
  if (!m.pause && m.status !== "paused") return null;
  const reward = m.pause?.reason === "referral_reward";

  const resume = async () => {
    setBusy(true);
    try { const r = await api.post(`/memberships/public/${token}/resume`); onChange(r.data); toast.success("Welcome back — membership active"); }
    catch (err) { toast.error(err?.response?.data?.detail || "Couldn't resume — call 310-422-0669"); }
    finally { setBusy(false); }
  };

  if (reward) {
    return (
      <div className="mt-4 rounded-xl border border-[#FFD600]/40 bg-[#FFD600]/10 p-4 text-sm flex items-start gap-3" data-testid="membership-reward-pause">
        <Gift className="w-5 h-5 text-[#FFD600] shrink-0 mt-0.5" />
        <div>
          <div className="font-semibold text-[#FFD600]">Free month — thanks for the referral!</div>
          <div className="text-slate-200 mt-0.5">Stripe skips your charge on {fmt(m.pause.pause_effective_date)}. Your perks stay on the whole time; normal billing resumes {fmt(m.pause.resume_effective_date)}.</div>
        </div>
      </div>
    );
  }
  return (
    <div className="mt-4 rounded-xl border border-amber-500/30 bg-amber-500/10 p-4 text-sm" data-testid="membership-pause">
      <div className="flex items-start gap-3">
        <PauseCircle className="w-5 h-5 text-amber-300 shrink-0 mt-0.5" />
        <div className="flex-1">
          <div className="font-semibold text-amber-100">{m.status === "paused" ? "Your membership is paused." : "Pause scheduled."}</div>
          <div className="text-amber-100/80 mt-0.5">
            {m.status === "paused"
              ? <>No charge this month and perks are off. Billing and perks come back automatically on {fmt(m.pause?.resume_effective_date)}.</>
              : <>Stripe skips your charge on {fmt(m.pause?.pause_effective_date)}; perks pause then too. Everything comes back automatically on {fmt(m.pause?.resume_effective_date)}.</>}
          </div>
          <button type="button" onClick={resume} disabled={busy} className="dg-btn-primary rounded-full px-4 py-2 text-sm mt-3 inline-flex items-center gap-2 disabled:opacity-50" data-testid="membership-resume-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <PlayCircle className="w-4 h-4" />} Resume now
          </button>
        </div>
      </div>
    </div>
  );
}
